import {LitElement, ReactiveController} from "lit";

export class SpLongPressController implements ReactiveController {
    host: LitElement;
    options: SpLongPressOptions;
    longPressTimer;
    longPressActive = false;

    startLongPressListener = this.startLongPress.bind(this);
    stopLongPressListener = this.stopLongPress.bind(this);
    touchMoveListener = this.touchMove.bind(this);

    constructor(host: LitElement, options?: SpLongPressOptions) {
        (this.host = host).addController(this);
        this.options = {
            active: true,
            timeoutMs: 300,
            suppressClickEventAtLongPressEnd: true,
            ...options
        };
    }

    updateOptions(options: SpLongPressOptions) {
        this.options = {
            ...this.options,
            ...options
        };
    }

    hostConnected() {
        this.host.addEventListener('mousedown', this.startLongPressListener);
        this.host.addEventListener('touchstart', this.startLongPressListener);
        this.host.addEventListener('touchmove', this.touchMoveListener);
    }

    hostDisconnected() {
        this.host.removeEventListener('mousedown', this.startLongPressListener);
        this.host.removeEventListener('touchstart', this.startLongPressListener);
        this.host.addEventListener('touchmove', this.touchMoveListener);
        document.removeEventListener('click', this.stopLongPressListener);
        document.removeEventListener('touchend', this.stopLongPressListener);
    }


    startLongPress(e: MouseEvent) {
        if (e.button === 0 || e.type === 'touchstart') {
            if (e.type === 'touchstart') {
                e.preventDefault();
            }
            document.addEventListener('click', this.stopLongPressListener, { once: true });
            document.addEventListener('touchend', this.stopLongPressListener, { once: true });
            this.longPressTimer = setTimeout(() => {
                this.host.dispatchEvent(new Event('long-press-start', {bubbles: true, composed: true}));
                this.longPressTimer = null;
                this.longPressActive = true;
            }, this.options.timeoutMs);
        }
    }

    stopLongPress(e: MouseEvent) {
        if (e.button === 0 || e.type === 'touchend') {
            if (this.longPressTimer) {
                clearTimeout(this.longPressTimer);
                // Emulate click which was suppressed in touchstart listener
                if (e.type === 'touchend') {
                    e.composedPath()[0].dispatchEvent(new MouseEvent('click', {
                        view: window,
                        cancelable: true,
                        composed: true,
                        bubbles: true
                    }));
                }
            }
            else if (this.longPressActive) {
                if (this.options.suppressClickEventAtLongPressEnd) {
                    e.stopPropagation();
                    e.preventDefault();
                }
                this.host.dispatchEvent(new Event('long-press-end', {bubbles: true, composed: true}));
                this.longPressActive = false;
            }
        }
    }

    touchMove(e: TouchEvent) {
        if (this.longPressActive) {
            // Suppress scrolling behavior
            e.preventDefault();
            e.stopPropagation();
        }
    }
}

export interface SpLongPressOptions {
    active: boolean;
    timeoutMs?: number;
    suppressClickEventAtLongPressEnd?: boolean;
}